export const LAZY_MODULE_URLS = JSON.parse(document.getElementById("lazy-game-graph").textContent);